module.exports = __webpack_public_path__ + "img/close.678bac35.svg";